import { render, staticRenderFns } from "./AnswerDetail.vue?vue&type=template&id=ef3f6502&"
import script from "./AnswerDetail.vue?vue&type=script&lang=js&"
export * from "./AnswerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports